(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4714],{

/***/ 74953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ BlogItem; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Blog_BlogTag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9294);
/* harmony import */ var _components_elements_Blog_Interviewee__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1300);
/* harmony import */ var _hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7257);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var BlogItem = function BlogItem(_ref) {
  var _id = _ref._id,
      coverImage = _ref.coverImage,
      title = _ref.title,
      tag = _ref.tag,
      publishDate = _ref.publishDate,
      interviewee = _ref.interviewee;
  var isMobile = (0,_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_5__/* .useMediaQuery */ .a)('(max-width: 1047px)');
  var cover = isMobile && coverImage.spCoverImage ? coverImage.spCoverImage : coverImage.pcCoverImage;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Article, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/news/blog/".concat(_id),
      passHref: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CoverImage, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
            src: cover.src,
            height: "100%",
            width: "100%",
            alt: cover.altText
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Content, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Date, {
              dateTime: publishDate,
              children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(publishDate, 'yyyy.MM.dd')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Title, {
              children: title
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(TagWrapper, {
              children: tag.map(function (tagItem) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_elements_Blog_BlogTag__WEBPACK_IMPORTED_MODULE_3__/* .BlogTag */ .F, _objectSpread({}, tagItem), tagItem._id);
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_elements_Blog_Interviewee__WEBPACK_IMPORTED_MODULE_4__/* .Interviewee */ .d, _objectSpread({}, interviewee))]
          })]
        })]
      })
    })
  });
};
var Article = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].article.withConfig */ .ZP.article.withConfig({
  displayName: "BlogItem__Article",
  componentId: "sc-w76rui-0"
})(["width:316px;height:447px;transition:0.3s;&:hover{> a > div > img{opacity:0.6;}time,h3{color:", ";}}@media screen and (max-width:1047px){width:100%;height:451px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue);
var CoverImage = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BlogItem__CoverImage",
  componentId: "sc-w76rui-1"
})(["height:188px;> img{border-radius:8px 8px 0 0;object-fit:cover;}@media screen and (max-width:1047px){height:208px;}"]);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BlogItem__Content",
  componentId: "sc-w76rui-2"
})(["height:calc(100% - 188px);padding:19px 25px 26px;display:flex;flex-direction:column;justify-content:space-between;background-color:#ffffff;border-style:solid;border-color:", ";border-width:0 2px 2px 2px;border-radius:0 0 8px 8px;> div{overflow:hidden;}@media screen and (max-width:1047px){height:calc(100% - 208px);padding:18px 22px 24px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.backgroundPaleBlue */ .r.colors.backgroundPaleBlue);
var Date = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "BlogItem__Date",
  componentId: "sc-w76rui-3"
})(["color:", ";font-size:12px;letter-spacing:1.2px;"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.textSecond */ .r.colors.textSecond);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "BlogItem__Title",
  componentId: "sc-w76rui-4"
})(["font-size:18px;line-height:24px;letter-spacing:1.8px;color:", ";font-weight:bold;height:74px;margin-top:9px;@media screen and (max-width:1047px){font-size:16px;letter-spacing:1.6px;margin-top:8px;height:72px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.textTitle */ .r.colors.textTitle);
var TagWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BlogItem__TagWrapper",
  componentId: "sc-w76rui-5"
})(["display:flex;align-items:center;gap:10px;margin-bottom:19px;"]);

/***/ }),

/***/ 9294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BlogTag; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var BlogTag = function BlogTag(_ref) {
  var name = _ref.name,
      tagColor = _ref.tagColor;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
    color: tagColor,
    children: ["#", name]
  });
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "BlogTag__Tag",
  componentId: "sc-1yvutcw-0"
})(["font-size:16px;line-height:27px;letter-spacing:0;color:#ffffff;background-color:", ";padding:0 18px 0 16px;border-radius:14px;@media screen and (max-width:1047px){font-size:13px;line-height:23px;}"], function (_ref2) {
  var color = _ref2.color;
  return color;
});

/***/ }),

/***/ 1300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Interviewee; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Interviewee = function Interviewee(_ref) {
  var profileImage = _ref.profileImage,
      fullName = _ref.fullName,
      biography = _ref.biography;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
      src: profileImage.src,
      width: "44px",
      height: "44px",
      alt: fullName
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EditorName, {
        children: fullName
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EditorPosition, {
        children: biography
      })]
    })]
  });
};
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__Content",
  componentId: "sc-13t4m1r-0"
})(["display:flex;align-items:center;gap:13px;"]);
var Image = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "Interviewee__Image",
  componentId: "sc-13t4m1r-1"
})(["border-radius:50%;"]);
var EditorName = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__EditorName",
  componentId: "sc-13t4m1r-2"
})(["font-size:15px;line-height:17px;letter-spacing:1.5px;color:", ";margin-bottom:2px;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var EditorPosition = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Interviewee__EditorPosition",
  componentId: "sc-13t4m1r-3"
})(["font-size:11px;line-height:15px;letter-spacing:1.1px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 63279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/utils/number.ts



var _marked = /*#__PURE__*/regenerator_default().mark(rangeGenerator);

function rangeGenerator(start, end) {
  var interval,
      i,
      _args = arguments;
  return regenerator_default().wrap(function rangeGenerator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          interval = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1;
          i = start;

        case 2:
          if (!(i <= end)) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return i;

        case 5:
          i += interval;
          _context.next = 2;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * 指定した範囲の配列を生成する
 */


var range = function range(start, end) {
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return (0,toConsumableArray/* default */.Z)(rangeGenerator(start, end, interval));
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Pagination/PaginationButton.tsx


var _excluded = ["page", "isActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PaginationButton = function PaginationButton(_ref) {
  var page = _ref.page,
      isActive = _ref.isActive,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (page === 'next') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButton, _objectSpread(_objectSpread({
        type: "button"
      }, props), {}, {
        "aria-label": "\u6B21\u306E\u30DA\u30FC\u30B8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NextIcon, {})
      }))
    });
  }

  if (page === 'before') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButton, _objectSpread(_objectSpread({
        type: "button"
      }, props), {}, {
        "aria-label": "\u524D\u306E\u30DA\u30FC\u30B8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BeforeIcon, {})
      }))
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, _objectSpread(_objectSpread({
      type: "button",
      "aria-current": isActive ? 'page' : undefined
    }, props), {}, {
      children: page
    }))
  });
};
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "PaginationButton__Button",
  componentId: "sc-1ianbpk-0"
})(["display:grid;place-content:center;width:46px;height:44px;font-size:16px;line-height:27px;border:1px solid ", ";background-color:#ffffff;color:", ";border-radius:2px;cursor:pointer;transition:all 0.3s ease-out;&:hover{background-color:", ";color:#ffffff;> svg{color:#ffffff;}}&[aria-current='page']{background-color:", ";color:#ffffff;cursor:initial;pointer-events:none;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var ArrowButton = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "PaginationButton__ArrowButton",
  componentId: "sc-1ianbpk-1"
})(["display:grid;place-content:center;"]);
var NextIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdNavigateNext */.sOJ).withConfig({
  displayName: "PaginationButton__NextIcon",
  componentId: "sc-1ianbpk-2"
})(["color:", ";font-size:22px;"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var BeforeIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdNavigateBefore */.D68).withConfig({
  displayName: "PaginationButton__BeforeIcon",
  componentId: "sc-1ianbpk-3"
})(["color:", ";font-size:22px;"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
;// CONCATENATED MODULE: ./src/components/elements/Pagination/index.tsx








var MAX_DISPLAY_COUNT = 5;

var createPageList = function createPageList(currentPage, totalPageCount) {
  // 5ページ未満
  if (totalPageCount < MAX_DISPLAY_COUNT) {
    return range(1, totalPageCount);
  } // 最初の2ページ


  if (currentPage < 3) {
    var end = Math.min(MAX_DISPLAY_COUNT, totalPageCount);
    return range(1, end);
  } // 最後の2ページ


  if (currentPage > totalPageCount - 3) {
    return range(totalPageCount - (MAX_DISPLAY_COUNT - 1), totalPageCount);
  }

  return range(currentPage - 2, currentPage + 2);
};

var Pagination = function Pagination(_ref) {
  var totalCount = _ref.totalCount,
      countPerPage = _ref.countPerPage,
      currentPage = _ref.currentPage,
      transitionPage = _ref.transitionPage;

  if (totalCount === 0) {
    return null;
  }

  var lastPage = Math.ceil(totalCount / countPerPage);
  var pageList = createPageList(currentPage, lastPage);
  var isFirstPage = currentPage === 1;
  var isLastPage = currentPage === lastPage;
  var isIncludeFirstPage = pageList[0] === 1;
  var isIncludeLastPage = pageList.at(-1) === lastPage;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    "aria-label": "\u30DA\u30FC\u30B8\u30CD\u30FC\u30B7\u30E7\u30F3",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(List, {
      children: [!isFirstPage && /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
        page: "before",
        onClick: function onClick() {
          return transitionPage(function (prev) {
            return prev - 1;
          });
        }
      }), !isIncludeFirstPage && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
          page: 1,
          onClick: function onClick() {
            return transitionPage(1);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ellipsis, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EllipsisIcon, {})
        })]
      }), pageList.map(function (page) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
          page: page,
          isActive: page === currentPage,
          onClick: function onClick() {
            return transitionPage(page);
          }
        }, page);
      }), !isIncludeLastPage && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ellipsis, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EllipsisIcon, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
          page: lastPage,
          onClick: function onClick() {
            return transitionPage(lastPage);
          }
        })]
      }), !isLastPage && /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
        page: "next",
        onClick: function onClick() {
          return transitionPage(function (prev) {
            return prev + 1;
          });
        }
      })]
    })
  });
};
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Pagination__List",
  componentId: "sc-5bez2-0"
})(["display:flex;flex-wrap:wrap;justify-content:center;gap:14px;@media screen and (max-width:1047px){gap:8px;}"]);
var Ellipsis = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Pagination__Ellipsis",
  componentId: "sc-5bez2-1"
})(["display:grid;place-content:center;margin:0 10px;@media screen and (max-width:1047px){margin:0 5px;}"]);
var EllipsisIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdMoreHoriz */.xr$).withConfig({
  displayName: "Pagination__EllipsisIcon",
  componentId: "sc-5bez2-2"
})(["color:", ";"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 97818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ monthOptions; },
/* harmony export */   "S4": function() { return /* binding */ getYearList; },
/* harmony export */   "hP": function() { return /* binding */ getYearOptions; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16645);


var getYearList = function getYearList(list) {
  var yearList = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Set(list.map(function (_ref) {
    var publishDate = _ref.publishDate;
    return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .formatDate */ .p6)(publishDate, 'yyyy');
  })));

  yearList.sort(function (a, b) {
    return Number(b) - Number(a);
  });
  return yearList;
};
var getYearOptions = function getYearOptions(list) {
  var yearList = getYearList(list);
  var yearOptions = yearList.map(function (y) {
    return {
      value: y,
      text: "".concat(y, "\u5E74")
    };
  });
  return [{
    value: '',
    text: 'すべての年'
  }].concat((0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(yearOptions));
};
var monthOptions = [{
  value: '',
  text: 'すべての月'
}, {
  value: '1',
  text: '1月'
}, {
  value: '2',
  text: '2月'
}, {
  value: '3',
  text: '3月'
}, {
  value: '4',
  text: '4月'
}, {
  value: '5',
  text: '5月'
}, {
  value: '6',
  text: '6月'
}, {
  value: '7',
  text: '7月'
}, {
  value: '8',
  text: '8月'
}, {
  value: '9',
  text: '9月'
}, {
  value: '10',
  text: '10月'
}, {
  value: '11',
  text: '11月'
}, {
  value: '12',
  text: '12月'
}];

/***/ }),

/***/ 14156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useFadeTransition; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29667);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var useFadeTransition = function useFadeTransition(duration) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      inProp = _useState[0],
      setInProp = _useState[1];

  var nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  /**
   * トランジションが発生してから関数を実行させる
   */

  var transitionFn = function transitionFn(fn) {
    setInProp(true);
    setTimeout(function () {
      fn();
    }, duration);
  };

  var render = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (_children) {
    var defaultStyle = {
      transition: "opacity ".concat(duration, "ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"),
      opacity: 1
    };
    var transitionStyle = {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 1
      },
      exited: {
        opacity: 1
      },
      unmounted: {
        opacity: 0
      }
    };
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
      nodeRef: nodeRef,
      "in": inProp,
      timeout: duration,
      onEntered: function onEntered() {
        return setInProp(false);
      },
      children: function children(state) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          ref: nodeRef,
          style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyle[state]),
          children: _children
        });
      }
    });
  }, [duration, inProp, nodeRef]);
  return {
    render: render,
    transitionFn: transitionFn
  };
};

/***/ }),

/***/ 7257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMediaQuery = function useMediaQuery(mediaQuery) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMatch = _useState[0],
      setIsMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var mediaQueryList = window.matchMedia(mediaQuery);

    var documentChangeHandler = function documentChangeHandler() {
      setIsMatch(mediaQueryList.matches);
    };

    mediaQueryList.addEventListener('change', documentChangeHandler);
    documentChangeHandler();
    return function () {
      mediaQueryList.removeEventListener('change', documentChangeHandler);
    };
  }, [mediaQuery]);
  return isMatch;
};

/***/ }),

/***/ 82485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ BlogPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/AccordionFilter.tsx






var AccordionFilter = function AccordionFilter(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(false),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var id = (0,react.useId)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Button, {
      type: "button",
      onClick: function onClick() {
        return setIsExpand(function (prev) {
          return !prev;
        });
      },
      "aria-expanded": isExpand,
      "aria-controls": id,
      children: ["\u7D5E\u308A\u8FBC\u307F", isExpand ? /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIcon, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(OpenIcon, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
      id: id,
      children: children
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccordionFilter__Wrapper",
  componentId: "sc-oh14hy-0"
})(["@media screen and (max-width:1047px){padding:0 20px;}"]);
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "AccordionFilter__Button",
  componentId: "sc-oh14hy-1"
})(["display:none;@media screen and (max-width:1047px){width:100%;height:50px;margin:0 auto;padding:0 22px;display:flex;align-items:center;justify-content:space-between;font-size:16px;font-weight:bold;color:", ";background-color:", ";border:none;border-radius:8px;&[aria-expanded='true']{border-bottom-left-radius:0;border-bottom-right-radius:0;}&[aria-expanded='false'] + div{height:0;padding-top:0;padding-bottom:0;opacity:0;overflow:hidden;pointer-events:none;}}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccordionFilter__Content",
  componentId: "sc-oh14hy-2"
})(["display:flex;flex-direction:column;gap:20px;@media screen and (max-width:1047px){transition:0.3s;padding:26px 22px;gap:24px;background:", ";border-top-right-radius:0;border-top-left-radius:0;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var OpenIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdAdd */.x06).withConfig({
  displayName: "AccordionFilter__OpenIcon",
  componentId: "sc-oh14hy-3"
})(["font-size:30px;color:", ";"], theme/* theme.colors.grey */.r.colors.grey);
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdRemove */.eqC).withConfig({
  displayName: "AccordionFilter__CloseIcon",
  componentId: "sc-oh14hy-4"
})(["font-size:30px;color:", ";"], theme/* theme.colors.grey */.r.colors.grey);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./src/components/elements/Blog/BlogTagButton/index.tsx


var _excluded = ["tag", "isActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var BlogTagButton = function BlogTagButton(_ref) {
  var tag = _ref.tag,
      isActive = _ref.isActive,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TagButton, _objectSpread(_objectSpread({
    type: "button",
    "aria-pressed": isActive,
    color: tag.tagColor
  }, props), {}, {
    children: tag.name
  }));
};
var TagButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "BlogTagButton__TagButton",
  componentId: "sc-ccd8k6-0"
})(["font-size:16px;line-height:27px;letter-spacing:0;background-color:#ffffff;color:", ";padding:0 18px 0 16px;border:1px solid ", ";border-radius:14px;cursor:pointer;transition:0.3s;&[disabled]{cursor:default;}@media (hover:hover){&:hover{opacity:0.6;}}&[aria-pressed='true']{color:#ffffff;background-color:", ";}"], function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var color = _ref4.color;
  return color;
});
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/Filter.tsx







var Filter = function Filter(_ref) {
  var years = _ref.years,
      tagList = _ref.tagList,
      selectedTags = _ref.selectedTags,
      selectedYears = _ref.selectedYears,
      changeSelectedYear = _ref.changeSelectedYear,
      changeSelectedTag = _ref.changeSelectedTag,
      handleAllTags = _ref.handleAllTags,
      handleAllYears = _ref.handleAllYears;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AccordionFilter, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Field, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: "\u63B2\u8F09\u65E5"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TagList, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BlogTagButton, {
          tag: {
            tagColor: theme/* theme.colors.trialBlue */.r.colors.trialBlue,
            name: 'すべて'
          },
          isActive: selectedYears.length === 0,
          onClick: handleAllYears,
          disabled: selectedYears.length === 0
        }), years.map(function (year) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogTagButton, {
            tag: {
              tagColor: theme/* theme.colors.textSecond */.r.colors.textSecond,
              name: year
            },
            isActive: selectedYears.includes(year),
            onClick: function onClick() {
              return changeSelectedYear(year);
            }
          }, year);
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpLine, {
      color: "grey",
      weight: 1,
      direction: "horizon"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Field, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: "\u30BF\u30B0"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TagList, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BlogTagButton, {
          tag: {
            tagColor: theme/* theme.colors.trialBlue */.r.colors.trialBlue,
            name: 'すべて'
          },
          isActive: selectedTags.length === 0,
          onClick: handleAllTags,
          disabled: selectedTags.length === 0
        }), tagList.map(function (_ref2) {
          var _id = _ref2._id,
              name = _ref2.name,
              tagColor = _ref2.tagColor;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogTagButton, {
            tag: {
              tagColor: tagColor,
              name: "#".concat(name)
            },
            isActive: selectedTags.includes(name),
            onClick: function onClick() {
              return changeSelectedTag(name);
            }
          }, _id);
        })]
      })]
    })]
  });
};
var Field = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filter__Field",
  componentId: "sc-1s69b5d-0"
})(["display:block;@media screen and (max-width:1047px){display:flex;flex-direction:column;gap:20px;}"]);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filter__Title",
  componentId: "sc-1s69b5d-1"
})(["display:none;@media screen and (max-width:1047px){display:block;font-size:14px;letter-spacing:0;line-height:24px;color:", ";}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var TagList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Filter__TagList",
  componentId: "sc-1s69b5d-2"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:12px;"]);
var SpLine = (0,styled_components_browser_esm/* default */.ZP)(Line/* Line */.x).withConfig({
  displayName: "Filter__SpLine",
  componentId: "sc-1s69b5d-3"
})(["display:none;@media screen and (max-width:1047px){display:block;}"]);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/useBlogList.ts



var useBlogList = function useBlogList(blogList, countPerPage) {
  var _useState = (0,react.useState)([]),
      selectedYears = _useState[0],
      setSelectedYears = _useState[1];

  var _useState2 = (0,react.useState)([]),
      selectedTags = _useState2[0],
      setSelectedTags = _useState2[1];

  var _useState3 = (0,react.useState)(1),
      currentPage = _useState3[0],
      setCurrentPage = _useState3[1];

  var filteredBlogList = (0,react.useMemo)(function () {
    return blogList.filter(function (_ref) {
      var tag = _ref.tag,
          publishDate = _ref.publishDate;
      var yearFilter = selectedYears.length > 0 ? selectedYears.some(function (year) {
        return (0,date/* isEqualYear */.bp)(publishDate, year);
      }) : true;
      var tagFilter = selectedTags.length > 0 ? tag.map(function (_ref2) {
        var name = _ref2.name;
        return name;
      }).some(function (name) {
        return selectedTags.includes(name);
      }) : true;
      return yearFilter && tagFilter;
    });
  }, [blogList, selectedTags, selectedYears]);
  var displayBlogList = (0,react.useMemo)(function () {
    var start = countPerPage * (currentPage - 1);
    var end = start + countPerPage;
    var list = filteredBlogList.slice(start, filteredBlogList.length < end ? undefined : end);
    return list;
  }, [currentPage, filteredBlogList, countPerPage]);
  var changeSelectedYear = (0,react.useCallback)(function (selectedYear) {
    setSelectedYears(function (currentYears) {
      if (currentYears.includes(selectedYear)) {
        return currentYears.filter(function (year) {
          return year !== selectedYear;
        });
      }

      return [].concat((0,toConsumableArray/* default */.Z)(currentYears), [selectedYear]);
    });
    setCurrentPage(1);
  }, []);
  var changeSelectedTag = (0,react.useCallback)(function (text) {
    setSelectedTags(function (currentTags) {
      if (currentTags.includes(text)) {
        return currentTags.filter(function (tag) {
          return tag !== text;
        });
      }

      return [].concat((0,toConsumableArray/* default */.Z)(currentTags), [text]);
    });
    setCurrentPage(1);
  }, []);
  var handleAllTags = (0,react.useCallback)(function () {
    setSelectedTags([]);
    setCurrentPage(1);
  }, []);
  var handleAllYears = (0,react.useCallback)(function () {
    setSelectedYears([]);
    setCurrentPage(1);
  }, []);
  var transitionPage = (0,react.useCallback)(function (value) {
    setCurrentPage(value);
    window.scrollTo({
      top: 0
    });
  }, []);
  return {
    selectedTags: selectedTags,
    selectedYears: selectedYears,
    displayBlogList: displayBlogList,
    totalCount: filteredBlogList.length,
    currentPage: currentPage,
    changeSelectedYear: changeSelectedYear,
    changeSelectedTag: changeSelectedTag,
    transitionPage: transitionPage,
    handleAllTags: handleAllTags,
    handleAllYears: handleAllYears
  };
};
// EXTERNAL MODULE: ./src/components/elements/Blog/BlogItem/index.tsx
var BlogItem = __webpack_require__(74953);
// EXTERNAL MODULE: ./src/components/elements/Pagination/index.tsx + 2 modules
var Pagination = __webpack_require__(63279);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/pages/News/dateOptions.ts
var dateOptions = __webpack_require__(97818);
// EXTERNAL MODULE: ./src/hooks/useFadeTransition.tsx
var useFadeTransition = __webpack_require__(14156);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/BlogList.tsx


function BlogList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function BlogList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BlogList_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BlogList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var BlogList = function BlogList(_ref) {
  var blogList = _ref.blogList,
      tagList = _ref.tagList;
  var COUNT_PER_PAGE = 9;

  var _useBlogList = useBlogList(blogList, COUNT_PER_PAGE),
      selectedTags = _useBlogList.selectedTags,
      selectedYears = _useBlogList.selectedYears,
      displayBlogList = _useBlogList.displayBlogList,
      currentPage = _useBlogList.currentPage,
      totalCount = _useBlogList.totalCount,
      _changeSelectedYear = _useBlogList.changeSelectedYear,
      _changeSelectedTag = _useBlogList.changeSelectedTag,
      transitionPage = _useBlogList.transitionPage,
      handleAllYears = _useBlogList.handleAllYears,
      handleAllTags = _useBlogList.handleAllTags;

  var _useFadeTransition = (0,useFadeTransition/* useFadeTransition */.W)(300),
      render = _useFadeTransition.render,
      transitionFn = _useFadeTransition.transitionFn;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Filter, {
      years: (0,dateOptions/* getYearList */.S4)(blogList),
      tagList: tagList,
      selectedTags: selectedTags,
      selectedYears: selectedYears,
      changeSelectedYear: function changeSelectedYear(year) {
        return transitionFn(function () {
          return _changeSelectedYear(year);
        });
      },
      changeSelectedTag: function changeSelectedTag(text) {
        return transitionFn(function () {
          return _changeSelectedTag(text);
        });
      },
      handleAllYears: handleAllYears,
      handleAllTags: handleAllTags
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 24,
        pc: 51
      }
    }), render( /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: displayBlogList.length > 0 ? displayBlogList.map(function (item) {
        return /*#__PURE__*/(0,react.createElement)(BlogItem/* BlogItem */.l, BlogList_objectSpread(BlogList_objectSpread({}, item), {}, {
          key: item._id
        }));
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: "\u4E00\u81F4\u3059\u308B\u8A18\u4E8B\u304C\u307F\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F"
      })
    })), totalCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 70,
          pc: 100
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
        totalCount: totalCount,
        countPerPage: COUNT_PER_PAGE,
        currentPage: currentPage,
        transitionPage: transitionPage
      })]
    })]
  });
};
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BlogList__List",
  componentId: "sc-1qs3xeq-0"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:47px 46px;@media screen and (max-width:1047px){flex-direction:column;justify-content:normal;row-gap:24px;padding:0 20px;}"]);
var Message = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "BlogList__Message",
  componentId: "sc-1qs3xeq-1"
})(["font-size:16px;letter-spacing:0.64px;line-height:26px;@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}"]);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/elements/Blog/BlogTag/index.tsx
var BlogTag = __webpack_require__(9294);
// EXTERNAL MODULE: ./src/components/elements/Blog/Interviewee/index.tsx
var Interviewee = __webpack_require__(1300);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(7257);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/PickUpArticle.tsx


function PickUpArticle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PickUpArticle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PickUpArticle_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PickUpArticle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var PickUpArticle = function PickUpArticle(_ref) {
  var _id = _ref._id,
      coverImage = _ref.coverImage,
      title = _ref.title,
      tag = _ref.tag,
      interviewee = _ref.interviewee,
      body = _ref.body,
      publishDate = _ref.publishDate,
      pickUpSummary = _ref.pickUpSummary;
  var isMobile = (0,useMediaQuery/* useMediaQuery */.a)('(max-width: 1047px)');
  var cover = isMobile ? coverImage.spCoverImage : coverImage.pcCoverImage;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: "/news/blog/".concat(_id),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Article, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: cover.src,
            alt: cover.altText
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PickUpArticle_Content, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
            dateTime: publishDate,
            children: (0,date/* formatDate */.p6)(publishDate, 'yyyy.MM.dd')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 8,
              pc: 13
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(PickUpArticle_Title, {
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 0,
              pc: 20
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            children: pickUpSummary
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 16,
              pc: 30
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TagWrapper, {
            children: tag.map(function (item) {
              return /*#__PURE__*/(0,react.createElement)(BlogTag/* BlogTag */.F, PickUpArticle_objectSpread(PickUpArticle_objectSpread({}, item), {}, {
                key: item._id
              }));
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 16,
              pc: 20
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Interviewee/* Interviewee */.d, PickUpArticle_objectSpread({}, interviewee))]
        })]
      })
    })
  });
};
var Article = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
  displayName: "PickUpArticle__Article",
  componentId: "sc-wjhsi4-0"
})(["display:flex;gap:44px;@media screen and (max-width:1047px){flex-direction:column;gap:0;position:relative;height:422px;}"]);
var ImgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpArticle__ImgWrapper",
  componentId: "sc-wjhsi4-1"
})(["margin:0 auto;@media screen and (max-width:1047px){margin:0;}> img{width:520px;height:309px;border-radius:12px;object-fit:cover;@media screen and (max-width:1047px){width:100%;height:232px;border-radius:0;}}"]);
var PickUpArticle_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpArticle__Content",
  componentId: "sc-wjhsi4-2"
})(["@media screen and (max-width:1047px){position:absolute;top:180px;left:0;right:0;height:243px;width:calc(100% - 40px);margin:0 auto;padding:18px 22px 24px;border:2px solid ", ";border-radius:8px;background-color:#ffffff;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Time = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "PickUpArticle__Time",
  componentId: "sc-wjhsi4-3"
})(["font-size:12px;letter-spacing:1.2px;line-height:25px;color:", ";"], theme/* theme.colors.textSecond */.r.colors.textSecond);
var PickUpArticle_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "PickUpArticle__Title",
  componentId: "sc-wjhsi4-4"
})(["font-size:28px;font-weight:bold;letter-spacing:2.8px;line-height:38px;color:", ";@media screen and (max-width:1047px){font-size:16px;letter-spacing:1.6px;line-height:24px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "PickUpArticle__Description",
  componentId: "sc-wjhsi4-5"
})(["font-size:14px;letter-spacing:0.28px;line-height:24px;color:", ";@media screen and (max-width:1047px){display:none;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var TagWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PickUpArticle__TagWrapper",
  componentId: "sc-wjhsi4-6"
})(["display:flex;align-items:center;"]);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/News/Blog/index.tsx


function Blog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Blog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Blog_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Blog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var BlogPage = function BlogPage(_ref) {
  var blogList = _ref.blogList,
      tagList = _ref.tagList;
  var pickUpArticle = blogList.find(function (_ref2) {
    var isPickUp = _ref2.isPickUp;
    return isPickUp;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      titleText: "TRIAL Blog",
      subTitleText: "\u5E83\u5831\u30D6\u30ED\u30B0",
      color: "normal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 50,
        pc: 73
      }
    }), pickUpArticle && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PickUpArticle, Blog_objectSpread({}, pickUpArticle)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 24,
          pc: 60
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogList, {
      blogList: blogList,
      tagList: tagList
    })]
  });
};

BlogPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'ニュースルーム',
    path: '/news/'
  }, {
    name: '広報ブログ',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u5E83\u5831\u30D6\u30ED\u30B0",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u5E83\u5831\u90E8\u304C\u304A\u5C4A\u3051\u3059\u308B\u30D6\u30ED\u30B0\u3067\u3059\u3002",
      ogp: {
        url: 'news/blog/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, Blog_objectSpread(Blog_objectSpread({}, pageTitle), {}, {
      breadCrumbs: breadCrumbs,
      children: page
    }))]
  });
};

var Wapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Blog__Wapper",
  componentId: "sc-1o2lmlr-0"
})(["width:1040px;margin:0 auto;padding:70px 0 130px;@media screen and (max-width:1047px){width:100%;padding:36px 0 80px;}"]);
;// CONCATENATED MODULE: ./src/pages/news/blog/index.tsx
var __N_SSG = true;


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 83397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/blog",
      function () {
        return __webpack_require__(82485);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5716,5548,9774,2888,179], function() { return __webpack_exec__(83397); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);